import * as types from './mutation-types'

export const updateField = ({ commit }, field) => {
  commit(types.UPDATE_FIELD, field)
}



// WEBPACK FOOTER //
// ./src/store/actions.js